import React from 'react';
import {Alert, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import {regenerateIds} from '../../../services/idHelpers';
import Icon from '../../Icon';
import TooltipContainer from '../../TooltipContainer';

class RegenerateIdsButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.confirm = this.confirm.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    confirm() {
        return this.setState({modal: false}, () => {
            const newEditor = regenerateIds(this.props.editor);
            this.props.setFieldValue('editor', newEditor);
        });
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        return (
            <TooltipContainer component="button" tooltip={messages.surveys.tooltips.regenerateIds}
                className="btn btn-link" type="button" onClick={this.toggleModal}>
                <Icon icon="update" />
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.surveys.modals.regenerateIds.title} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.surveys.modals.regenerateIds.body} />
                        <Alert color="danger" className="mt-3">
                            <FormattedMessage {...messages.surveys.modals.regenerateIds.alert} />
                        </Alert>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary" type="button" onClick={this.confirm}>
                            <FormattedMessage {...messages.buttons.ok} />
                        </button>
                    </ModalFooter>
                </Modal>
            </TooltipContainer>
        );
    }
}

export default RegenerateIdsButton;
